import {
  createContext,
  ReactNode,
  useCallback,
  useMemo,
  useState,
} from "react";

interface CartDrawerContextValue {
  isCartDrawerOpen: boolean;
  openCartDrawer: () => void;
  closeCartDrawer: () => void;
  toggleCartDrawer: () => void;
}

export const CartDrawerContext = createContext<CartDrawerContextValue | null>(
  null,
);

interface CartDrawerProviderProps {
  children: ReactNode;
}

export const CartDrawerProvider = ({ children }: CartDrawerProviderProps) => {
  const [isCartDrawerOpen, setIsCartDrawerOpen] = useState(false);

  const openCartDrawer = useCallback(() => {
    setIsCartDrawerOpen(true);
  }, []);

  const closeCartDrawer = useCallback(() => {
    setIsCartDrawerOpen(false);
  }, []);

  const toggleCartDrawer = useCallback(() => {
    setIsCartDrawerOpen((current) => !current);
  }, []);

  const value = useMemo(
    () => ({
      isCartDrawerOpen,
      openCartDrawer,
      closeCartDrawer,
      toggleCartDrawer,
    }),
    [closeCartDrawer, isCartDrawerOpen, openCartDrawer, toggleCartDrawer],
  );

  return (
    <CartDrawerContext.Provider value={value}>
      {children}
    </CartDrawerContext.Provider>
  );
};
